import { render, staticRenderFns } from "./ServeProduct.vue?vue&type=template&id=74ba2200&scoped=true&"
import script from "./ServeProduct.vue?vue&type=script&lang=js&"
export * from "./ServeProduct.vue?vue&type=script&lang=js&"
import style0 from "./ServeProduct.vue?vue&type=style&index=0&id=74ba2200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba2200",
  null
  
)

export default component.exports